import { colorPalettes } from '../color.config.js';
import { appNames } from '../lib/appNames';
import { App } from '../lib/app';
export function useColors() {
  const currentApp = process.env.CURRENT_APP || App.getAppName();
  const colors = colorPalettes[currentApp];

  return { colors };
}